import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { ChannelFlowCallbackRequestFilterSensitiveLog, } from "../models/models_0";
import { de_ChannelFlowCallbackCommand, se_ChannelFlowCallbackCommand } from "../protocols/Aws_restJson1";
export { $Command };
export class ChannelFlowCallbackCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("ChimeMessagingService", "ChannelFlowCallback", {})
    .n("ChimeSDKMessagingClient", "ChannelFlowCallbackCommand")
    .f(ChannelFlowCallbackRequestFilterSensitiveLog, void 0)
    .ser(se_ChannelFlowCallbackCommand)
    .de(de_ChannelFlowCallbackCommand)
    .build() {
}
